/**
 * Labstep
 *
 * @module components/User/Form/ShowEdit/Name
 * @desc User show edit form
 */

import {
  fieldUserFirstName,
  fieldUserLastName,
} from 'labstep-web/components/User/Form/fields';
import { FormShowEditTextMultiple as ShowEditTextMultiple } from 'labstep-web/core/Form/ShowEdit/Text/Multiple';
import { Header } from 'labstep-web/core/Header';
import type React from 'react';
import type { IUserFormShowEditNameProps } from './types';

export const UserFormShowEditName: React.FC<
  IUserFormShowEditNameProps
> = ({ user }) => (
  <ShowEditTextMultiple
    id={user.id}
    entity={user}
    entityName={user.entityName}
    fields={[fieldUserFirstName, fieldUserLastName]}
    customChildren={(children) => (
      <Header size="small" noMargin isDataPublic={false}>
        {children}
      </Header>
    )}
  />
);
